import { useEffect, useRef, useState } from "react";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import MenuLateral from "../components/MenuLateral/MenuLateralDashboard";
import HeaderDash from "../components/Header/HeaderDashboard";
import { LayoutMenu } from "../components/MenuUtilidades/LayoutMenu";
import { useLayout } from "../contexts/UseLayout";
import { LoadingInput } from "@/components/LoadingInput/LoadingInput";
import { useLocation } from "react-router-dom";
import { ViewToggle } from "@/components/ViewToggle/ViewToggle";
import { PageTransition } from "@/components/ui/PageTransition";
import { CopilotoGoOn } from "@/components/CopilotoGoOn";
import { QUERY_REFRESH_INTERVALS } from "@/constants/queryRefresh";
// import ModalVerificacaoCadastro from "@/components/ModalVerificacaoCadastro";

function RouteFallback() {
  return (
    <div className="p-5 text-center flex justify-center items-center">
      <LoadingInput classe="w-10 h-10 text-azul-400" />
    </div>
  );
}

export default function Layout() {
  const [selectedOption, setSelectedOption] = useState(null);
  const { menuOpen, setMenuOpen, getMe } = useLayout();
  const lastFocusSyncRef = useRef(0);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Função para detectar quando a janela ganha foco
  useEffect(() => {
    // tive que usar assim pq o react-query não estava atualizando a página quando dava o foco.
    const handleWindowFocus = () => {
      const now = Date.now();
      if (
        document.visibilityState === "hidden" ||
        now - lastFocusSyncRef.current < QUERY_REFRESH_INTERVALS.focusUserSync
      ) {
        return;
      }

      lastFocusSyncRef.current = now;
      getMe(true);
    };

    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [getMe]);

  return (
    <div className="flex relative bg-cinza-100">
      <MenuLateral />
      <main
        className={`flex-1 min-w-0 transition-all px-4 duration-300 pb-14 sm:pb-0 ${
          menuOpen ? "mr-[360px] w-auto" : "md:mr-10"
        }`}
      >
        <HeaderDash />
        <Suspense fallback={<RouteFallback />}>
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </Suspense>
      </main>
      <aside className="h-dvh fixed top-0 right-0 py-4 max-h-dvh z-10">
        <LayoutMenu
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </aside>
      <ViewToggle />
      <CopilotoGoOn />
      {/* <ModalVerificacaoCadastro /> */}
    </div>
  );
}
